import React from "react";
import { Instagram, Mail, MessageCircle, MapPin } from "lucide-react";
import { waUrl, WA_NUMBER } from "../lib/api";
import Logo from "./Logo";

const formatWA = (num) => `+${num.slice(0, 2)} ${num.slice(2, 5)}-${num.slice(5, 9)}-${num.slice(9)}`;

export default function Footer() {
    return (
        <footer className="bg-[#0A1A2F] text-white pb-24 md:pb-0" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
                <div className="grid md:grid-cols-12 gap-10 md:gap-14">
                    <div className="md:col-span-5">
                        <Logo size={42} dark />
                        <p className="text-slate-300 text-sm mt-5 leading-relaxed max-w-md" data-testid="footer-description">
                            <strong className="text-white">Smart study abroad matching</strong> + bimbingan{" "}
                            <strong className="text-white">Counselor Senior</strong> untuk pelajar Indonesia dan keluarga.
                            Dari pemetaan kampus, simulasi biaya, hingga pendampingan aplikasi & visa.
                        </p>

                        <div className="mt-7 flex items-center gap-3">
                            <a
                                href={waUrl()}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-wa"
                                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#25D366] flex items-center justify-center transition"
                                aria-label="WhatsApp"
                            >
                                <MessageCircle className="w-4 h-4" />
                            </a>
                            <a
                                href="mailto:hello@gantariedu.com"
                                data-testid="footer-email"
                                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#F5A623] hover:text-[#0A1A2F] flex items-center justify-center transition"
                                aria-label="Email"
                            >
                                <Mail className="w-4 h-4" />
                            </a>
                            <a
                                href="#"
                                data-testid="footer-ig"
                                className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#F5A623] hover:text-[#0A1A2F] flex items-center justify-center transition"
                                aria-label="Instagram"
                            >
                                <Instagram className="w-4 h-4" />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-display font-semibold mb-4 text-[#F5A623] text-sm uppercase tracking-wider">Menu</div>
                        <ul className="space-y-2.5 text-sm text-slate-300">
                            <li><a href="#smart-search" className="hover:text-white transition">Cari Kampus</a></li>
                            <li><a href="#roi" className="hover:text-white transition">Hitung Biaya & ROI</a></li>
                            <li><a href="#screener" className="hover:text-white transition">Cek Peluang Lolos</a></li>
                            <li><a href="#screener" className="hover:text-white transition">Cek Berkas</a></li>
                            <li><a href="#articles" className="hover:text-white transition">Artikel</a></li>
                            <li><a href="#portal" className="hover:text-white transition">Portal Klien</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-display font-semibold mb-4 text-[#F5A623] text-sm uppercase tracking-wider">Hubungi Kami</div>
                        <ul className="space-y-3 text-sm text-slate-300">
                            <li className="flex items-start gap-2.5">
                                <MessageCircle className="w-4 h-4 mt-0.5 text-[#F5A623] flex-shrink-0" />
                                <span>WhatsApp: <a href={waUrl()} className="hover:text-white">{formatWA(WA_NUMBER)}</a></span>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <Mail className="w-4 h-4 mt-0.5 text-[#F5A623] flex-shrink-0" />
                                <span>hello@gantariedu.com</span>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <Instagram className="w-4 h-4 mt-0.5 text-[#F5A623] flex-shrink-0" />
                                <span>@gantariedu</span>
                            </li>
                            <li className="flex items-start gap-2.5">
                                <MapPin className="w-4 h-4 mt-0.5 text-[#F5A623] flex-shrink-0" />
                                <span>Jakarta, Indonesia · Konsultasi online di seluruh Indonesia</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-white/10 mt-12 pt-6 text-xs text-slate-500 flex flex-col md:flex-row gap-3 justify-between items-center">
                    <div>© {new Date().getFullYear()} Gantari Edu. Semua hak dilindungi.</div>
                    <div className="flex gap-5">
                        <a href="#" className="hover:text-slate-300" data-testid="footer-privacy">Privacy Policy</a>
                        <a href="#" className="hover:text-slate-300" data-testid="footer-terms">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
